import { ChainId } from '@src/configs/chainInfo'
import { FEATURE_GATES } from '@src/configs/feature_gates'

// Check if a feature is enabled for the current environment
export const isFeatureEnabled = (feature: string): boolean => {
    const currentEnv = process.env.REACT_APP_NODE_ENV?.toUpperCase() || ''
    const enabledEnvs = FEATURE_GATES[feature] || []
    return enabledEnvs.includes(currentEnv)
}

// List of supported chains for V2 features
export const isV2SupportedChain = (chainId: number): boolean => {
    // optimism, arbitrum, avalanche, polygon, base, celo, bsc, tron
    const supportedChainList = new Set([
        ChainId.Ethereum,
        ChainId.Optimism,
        ChainId.Arbitrum,
        ChainId.Avalanche,
        ChainId.Polygon,
        ChainId.Base,
        ChainId.Celo,
        ChainId.Bsc,
        ChainId.Tron,
        ChainId.Solana,
        ChainId.Unichain,
        ChainId.Sepolia,
        ChainId.MonadTestnet,
        ChainId.MegaEthTestnet,
        ChainId.Mantle,
        ChainId.ApeChain,
    ])
    return supportedChainList.has(chainId)
}
